import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface DietPlanParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface DietPlan {
    id?: any;
    branchId: any;
    name:string;
    isActive:string;

    parameters?: DietPlanParameter[];
    links?: any;

    createdBy:string;
    createdDate:Date
    updatedBy:string;
    updatedDate:Date
    tenantId:any;
    createdIP?:string;
    updatedIP?:string;
    dietPlanDetailsDto?:any;
    recommendedCalories:any;
}


export abstract class DietPlanData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<DietPlan[]>;
    abstract create(url: string, data: DietPlan): Observable<DietPlan[]>;
    abstract update(url: string, data: DietPlan): Observable<DietPlan>;
    abstract delete(url: string): Observable<any>;
    abstract getById(url: string): Observable<DietPlan>;
}
